// Formatting utilities for the dashboard

/**
 * Format a price in USD with 2 decimal places.
 */
export function formatUSD(value: number | null | undefined): string {
  if (value == null) return '-';
  return `$${value.toFixed(2)}`;
}

/**
 * Format a $/GB value.
 */
export function formatPerGB(value: number | null | undefined): string {
  if (value == null) return '-';
  return `$${value.toFixed(2)}/GB`;
}

/**
 * Format a percentage change with sign and 1 decimal.
 */
export function formatDeltaPct(value: number | null | undefined): string {
  if (value == null) return '-';
  const sign = value >= 0 ? '+' : '';
  return `${sign}${value.toFixed(1)}%`;
}

/**
 * Format data in GB.
 */
export function formatGB(value: number | null | undefined): string {
  if (value == null) return '-';
  return `${value}GB`;
}

/**
 * Format validity in days.
 */
export function formatDays(value: number | null | undefined): string {
  if (value == null) return '-';
  return `${value}g`;
}

/**
 * Format a sentiment ratio as a percentage.
 */
export function formatPct(value: number | null | undefined): string {
  if (value == null) return '-';
  return `${Math.round(value * 100)}%`;
}

/**
 * Format a week key (YYYYWW) as a display string.
 */
export function formatWeek(weekKey: number): string {
  const year = Math.floor(weekKey / 100);
  const week = weekKey % 100;
  return `${year}-W${String(week).padStart(2, '0')}`;
}

/**
 * Format a date string for display.
 */
export function formatDate(isoDate: string): string {
  try {
    const d = new Date(isoDate);
    return d.toLocaleDateString('tr-TR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  } catch {
    return isoDate;
  }
}

/**
 * Clamp a number between min and max.
 */
export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}

/**
 * Get the delta class for color coding.
 */
export function deltaClass(value: number | null | undefined): string {
  if (value == null) return 'text-neutral-400';
  if (value > 0) return 'text-rose-400'; // Price increase = bad
  if (value < 0) return 'text-emerald-400'; // Price decrease = good
  return 'text-neutral-400';
}
